import * as React from "react";
import styled from "@emotion/styled";
import FormContext, { initFormStore } from "@/contexts/Form";
import form from "@/utils/form";
import breakpoint from "@/utils/breakpoint";
import ContractContext, { initContractStore } from "@/contexts/Contract";
import contract, { ContractExtras, Feature } from "@/utils/contract";
import { useTheme } from "@/hooks/useTheme";

type FormContainerProps = {
  children: React.ReactNode;
};

const Wrapper = styled.div`
  width: 1020px;
  margin: 0 auto;
  padding: 20px;

  ${breakpoint.lessThan("sm")`
    display: block;
    padding: 20px 10px;
    width: 100%;
  `}
`;

const FormProvider = ({ children }: FormContainerProps) => {
  const { isNewTheme } = useTheme();
  const {
    state: { featuresObj, propertyTypes },
  } = React.useContext(ContractContext) || initContractStore(contract);
  const CONTACT_PREFERENCE_TEL: { has: boolean; extras: ContractExtras } = {
    has: Boolean(featuresObj[Feature.CONTACT_PREFERENCE_TEL]),
    extras: featuresObj[Feature.CONTACT_PREFERENCE_TEL],
  };
  const CONTACT_PREFERENCE_MAIL: { has: boolean; extras: ContractExtras } = {
    has: Boolean(featuresObj[Feature.CONTACT_PREFERENCE_MAIL]),
    extras: featuresObj[Feature.CONTACT_PREFERENCE_MAIL],
  };
  let updatedValues = { ...form };

  if (CONTACT_PREFERENCE_TEL.has) {
    updatedValues = {
      ...updatedValues,
      values: {
        ...updatedValues.values,
        canContactTel: CONTACT_PREFERENCE_TEL.extras.default ?? true,
      },
    };
  }
  if (CONTACT_PREFERENCE_MAIL.has) {
    updatedValues = {
      ...updatedValues,
      values: {
        ...updatedValues.values,
        canContactMail: CONTACT_PREFERENCE_MAIL.extras.default ?? true,
      },
    };
  }
  if (propertyTypes && propertyTypes.length) {
    updatedValues = {
      ...updatedValues,
      values: {
        ...updatedValues.values,
        propertyType: propertyTypes[0],
      },
    };
  }

  const formStore = initFormStore(updatedValues);
  return (
    <FormContext.Provider value={formStore}>
      {isNewTheme ? <React.Fragment>{children}</React.Fragment> : <Wrapper>{children}</Wrapper>}
    </FormContext.Provider>
  );
};

export default FormProvider;
